import React, { useRef, useState } from "react";
import emailjs from "emailjs-com";

const InnerContactForm = () => {
  const form = useRef();
  const [statusMessage, setStatusMessage] = useState("");

  const sendEmail = (e) => {
    e.preventDefault();
    // alert("Email has been sent")
    emailjs
      .sendForm(
        "service_qcyb3i9", // Replace with your Service ID
        "template_azgr4kc", // Replace with your Template ID
        form.current,
        "1RXsJFuJBbikL5VTO" // Replace with your User ID
      )
      .then(
        (result) => {
          console.log(result.text);
          setStatusMessage("Email sent successfully!");
          form.current.reset(); // Reset form after submission
        },
        (error) => {
          console.log(error.text);
          setStatusMessage("Failed to send email. Please try again.");
        }
      );
  };

  return (
    <form ref={form} onSubmit={sendEmail}>
      <div className="form-grp">
        <label htmlFor="name">
          <i className="fas fa-user"></i>
        </label>
        <input type="text" id="name" name="user_name" placeholder="Name" required />
      </div>
      <div className="form-grp">
        <label htmlFor="phone">
          <i className="fas fa-phone"></i>
        </label>
        <input type="text" id="phone" name="user_phone" placeholder="Phone" required />
      </div>
      <div className="form-grp">
        <label htmlFor="email">
          <i className="fas fa-envelope"></i>
        </label>
        <input type="email" id="email" name="user_email" placeholder="Email Address" required />
      </div>
      <div className="form-grp">
        <label htmlFor="subject">
          <i className="fas fa-book-alt"></i>
        </label>
        <input type="text" id="subject" name="user_subject" placeholder="Subject" required />
      </div>
      <div className="form-grp">
        <label htmlFor="comment">
          <i className="fas fa-user-edit"></i>
        </label>
        <textarea
          name="message"
          id="comment"
          placeholder="How can we help you? Feel free to get in touch!"
          required
        ></textarea>
      </div>
      <button type="submit" className="btn">
        Send Message <span></span>
      </button>

      {statusMessage && <p className="status-message">{statusMessage}</p>}
    </form>
  );
};

export default InnerContactForm;
